export default __webpack_public_path__ + "static/media/Attachment.79d545f5.png";